import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, serviceHead } from "@/components/site/ServicePage";

const SLUG = "fejlfinding";
const TITLE = "Fejlfinding på el-installation | Akut elektriker København & omegn";
const DESC =
  "Springer din HPFI? Strømsvigt eller mystiske fejl? Vi laver systematisk fejlfinding og dokumenteret el-tjek i hele Storkøbenhavn, døgnvagt 24/7.";

export const Route = createFileRoute("/fejlfinding")({
  head: () => serviceHead(SLUG, TITLE, DESC),
  component: () => (
    <ServicePage
      slug={SLUG}
      heroVariant="compact"
      accentColor="oklch(0.65 0.2 28)"
      eyebrow="Fejlfinding & akut udrykning"
      title="Fejlfinding & el-tjek, vi finder fejlen før den finder dig"
      intro="Springer HPFI'en hele tiden? Slukker lyset i hele lejligheden uden grund? Dufter det brændt fra tavlen? Vi finder fejlen, hurtigt, systematisk og dokumenteret. Døgnvagt 24/7 i hele Storkøbenhavn."
      longIntro={
        <>
          <h2>De fleste “mystiske” el-fejl har en helt naturlig forklaring</h2>
          <p>
            HPFI-relæer der slår fra, sikringer der springer, lys der flimrer eller stikkontakter
            der bliver varme, det er sjældent tilfældigt og næsten aldrig harmløst. Det er
            installationens måde at fortælle dig, at noget er overbelastet, fugtigt, dårligt
            forbundet eller helt slidt op. Lader man det stå, ender det ofte med brand,
            personskade eller en regning der er mange gange større end den oprindelige reparation.
          </p>
          <p>
            Vi nærmer os fejlfinding som detektivarbejde: vi spørger ind til hvornår fejlen opstår,
            måler systematisk i tavlen, isolerer hver gruppe og finder den faktiske årsag, ikke
            bare et symptom vi kan slukke for. Du får altid forklaret hvad vi gør, hvad vi finder,
            og hvad vi anbefaler.
          </p>
        </>
      }
      bullets={[
        "Akut udrykning 24/7 i hele Storkøbenhavn",
        "Systematisk fejlfinding med målinger og isolation",
        "El-tjek og rapport, til forsikring, hushandel eller egen sindsro",
        "Reparation udført med det samme, hvis du ønsker det",
        "Termografering af tavle og kabler",
        "Du får altid pris og omfang oplyst undervejs",
      ]}
      features={[
        { title: "Akut udrykning", body: "Hjælp samme dag, også uden for normal arbejdstid og i weekenden ved akutte fejl." },
        { title: "El-tjek bolig", body: "Dokumenteret gennemgang af hele din installation med skriftlig rapport. Anbefales hvert 10. år." },
        { title: "El-tjek ved hushandel", body: "Inden du køber: vi tjekker tavle, jording, HPFI, gruppefordeling og dokumenterer fejl/mangler." },
        { title: "Termografering", body: "Vi finder skjulte varmegange før de udvikler sig til brandfare, særligt i ældre tavler." },
        { title: "HPFI-tjek", body: "HPFI-relæet skal testes hvert halve år. Vi tester, dokumenterer og udskifter hvis nødvendigt." },
        { title: "Jording", body: "Mangler dit hjem jordforbindelse? Vi tjekker, opretter og dokumenterer korrekt jording." },
      ]}
      process={[
        { title: "Du ringer", body: "Beskriv fejlen, vi vurderer om vi kan løse den telefonisk, om du skal slukke selv, og hvor hurtigt vi skal komme." },
        { title: "Diagnose", body: "Vi måler systematisk fra hovedmåler over tavle til den enkelte gruppe og isolerer fejlen." },
        { title: "Pris og aftale", body: "Du får oplyst hvad reparationen koster, før vi går i gang, også hvis det viser sig at være større end først antaget." },
        { title: "Reparation & dokumentation", body: "Vi reparerer, dokumenterer i KLS-rapporten og giver garanti på arbejdet." },
      ]}
      faq={[
        { q: "Hvor hurtigt kan I være der?", a: "Ved akutte opgaver typisk inden for 1-2 timer i Storkøbenhavn i åbningstiden. Døgnvagt 24/7 udenfor, vi rykker også ud nat og weekend." },
        { q: "Hvad koster det?", a: "Vi afregner i tid plus materialer ved fejlfinding, du får altid prisen oplyst undervejs. Se hele prislisten under Priser." },
        { q: "Får jeg en rapport?", a: "Ja, ved el-tjek får du en skriftlig rapport (KLS-rapport) der kan bruges til forsikring og hushandel. Også ved fejlfinding dokumenterer vi arbejdet." },
        { q: "Hvad er HPFI og hvorfor er det vigtigt?", a: "HPFI-relæet beskytter dig mod livsfarlige jordfejlsstrømme. Det er lovpligtigt i alle moderne installationer og skal testes hvert halve år ved at trykke på TEST-knappen, relæet skal slå fra med det samme." },
        { q: "Min sikring springer hele tiden, hvad gør jeg?", a: "Hvis det er den samme sikring der springer, har du en defekt enhed eller overbelastning på den gruppe. Sluk alt på gruppen, og tænd én enhed ad gangen. Hvis det er HPFI'en der slår fra, er der jordfejl et sted, ring til os." },
        { q: "Lugten af brændt, hvor farligt er det?", a: "Meget farligt. Brændt lugt betyder typisk overophedet kontakt, kabel eller komponent, og det kan udvikle sig til brand. Sluk på hovedafbryderen og ring til os med det samme." },
      ]}
      related={[
        { to: "/priser-privat", title: "Priser privat", body: "Se vores faste timepriser og takster for akut udrykning." },
        { to: "/energioptimering", title: "Energioptimering", body: "Mange fejl skyldes overbelastning, vi kan også optimere forbruget." },
        { to: "/tilbud", title: "Indhent tilbud", body: "Planlagt el-tjek? Få et fast tilbud uden forpligtelse." },
      ]}
    />
  ),
});
